import "./services.css";
import { Button, Container, Header, Grid, Icon } from "semantic-ui-react";
import { useNavigate } from "react-router-dom";
import { useStore } from "../../store/store";
import { setActiveMenuItem } from "../../store/reducer";

const Services = () => {
    const navigate = useNavigate();
    const [, dispatch] = useStore();

    const services = [
        {
            key: "ductwork-installation",
            title: "Ductwork Installation",
            icon: "wrench",
            description: "Specialist HVAC ductwork installation for commercial buildings, residential developments, and infrastructure projects, including HVDC and energy facilities."
        },
        {
            key: "ductwork-fabrication",
            title: "Rectangular & Bespoke Fabrication",
            icon: "industry",
            description: "DW144 compliant rectangular ductwork, galvanised steel sections, and made-to-order fittings manufactured to project specification."
        },
        {
            key: "fire-rated-ductwork",
            title: "Fire-Rated Ductwork Systems",
            icon: "fire extinguisher",
            description: "Supply, manufacture, and installation of fire-rated ductwork systems for safety-critical ventilation and extract requirements."
        },
        {
            key: "fire-damper-testing",
            title: "Fire Damper Testing & Certification",
            icon: "certificate",
            description: "Inspection, testing, certification, and reporting for fire dampers in line with current safety and compliance requirements."
        },
        {
            key: "hvac-maintenance",
            title: "HVAC Servicing & Maintenance",
            icon: "setting",
            description: "Planned and reactive servicing for ventilation and HVAC systems to support reliability, performance, and day-to-day operation."
        },
        {
            key: "ductwork-design",
            title: "HVAC Design, CAD & MEP Coordination",
            icon: "sitemap",
            description: "Ductwork design, CAD detailing, and full MEP coordination for commercial, residential, and infrastructure projects."
        }
    ];

    const handleQuoteClick = (event) => {
        event.preventDefault();
        dispatch(setActiveMenuItem("/contact"));
        navigate("/contact");
    };

    return (
        <Container className="services">
            <Grid stackable className="services-layout">
                <Grid.Column width={5}>
                    <Header as="h3" content="Services" className="services-h3" />
                    <p className="services-intro">
                        Complete ventilation and ductwork support from early coordination through manufacture, installation, testing, and maintenance.
                    </p>
                    <Button primary size="large" className="services-quote-button" onClick={handleQuoteClick}>
                        Request Quote
                    </Button>
                </Grid.Column>
                <Grid.Column width={11}>
                    <div className="services-list">
                        {services.map(({ key, title, icon, description }) => (
                            <div key={key} className="services-item">
                                <div className="services-item-heading">
                                    <div className="services-icon" aria-label={`${title} icon`} role="img">
                                        <Icon name={icon} size="large" />
                                    </div>
                                    <Header as="h4" className="services-title">{title}</Header>
                                </div>
                                <p className="services-desc">{description}</p>
                            </div>
                        ))}
                    </div>
                </Grid.Column>
            </Grid>
        </Container>
    );
};

export default Services;
